"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_1 = require("@inertiajs/inertia");
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ActionMessage_1 = __importDefault(require("@/Jetstream/ActionMessage"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var FormSection_1 = __importDefault(require("@/Jetstream/FormSection"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var InputError_1 = __importDefault(require("@/Jetstream/InputError"));
var Label_1 = __importDefault(require("@/Jetstream/Label"));
var SecondaryButton_1 = __importDefault(require("@/Jetstream/SecondaryButton"));
function UpdateProfileInformationForm(_a) {
    var user = _a.user;
    var form = (0, inertia_react_1.useForm)({
        _method: 'PUT',
        name: user.name,
        email: user.email,
        photo: null,
    });
    var route = (0, useRoute_1.default)();
    var _b = (0, react_1.useState)(null), photoPreview = _b[0], setPhotoPreview = _b[1];
    var photoRef = (0, react_1.useRef)(null);
    var page = (0, inertia_react_1.usePage)();
    function updateProfileInformation() {
        if (photoRef.current) {
            form.transform(function (data) {
                var _a, _b;
                return (__assign(__assign({}, data), { photo: ((_b = (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0]) || null }));
            });
        }
        form.post(route('user-profile-information.update'), {
            errorBag: 'updateProfileInformation',
            preserveScroll: true,
            onSuccess: function () { return clearPhotoFileInput(); },
        });
    }
    function selectNewPhoto() {
        var _a;
        (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    function updatePhotoPreview() {
        var _a, _b;
        var photo = (_b = (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
        if (!photo)
            return;
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            setPhotoPreview((_a = e.target) === null || _a === void 0 ? void 0 : _a.result);
        };
        reader.readAsDataURL(photo);
    }
    function deletePhoto() {
        inertia_1.Inertia.delete(route('current-user-photo.destroy'), {
            preserveScroll: true,
            onSuccess: function () {
                setPhotoPreview(null);
                clearPhotoFileInput();
            },
        });
    }
    function clearPhotoFileInput() {
        var _a;
        if ((_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            photoRef.current.value = '';
        }
    }
    return (react_1.default.createElement(FormSection_1.default, { onSubmit: updateProfileInformation, title: 'Profile Information', description: "Update your account's profile information and email address.", renderActions: function () { return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ActionMessage_1.default, { on: form.recentlySuccessful, className: "mr-3" }, "Saved."),
            react_1.default.createElement(Button_1.default, { className: (0, classnames_1.default)({ 'opacity-25': form.processing }), disabled: form.processing }, "Save"))); } },
        page.props.jetstream.managesProfilePhotos ? (react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
            react_1.default.createElement("input", { type: "file", className: "hidden", ref: photoRef, onChange: updatePhotoPreview }),
            react_1.default.createElement(Label_1.default, { htmlFor: "photo", value: "Photo" }),
            photoPreview ? (
            // <!-- New Profile Photo Preview -->
            react_1.default.createElement("div", { className: "mt-2" },
                react_1.default.createElement("span", { className: "block rounded-full w-20 h-20", style: {
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundImage: "url('".concat(photoPreview, "')"),
                    } }))) : (
            // <!-- Current Profile Photo -->
            react_1.default.createElement("div", { className: "mt-2" },
                react_1.default.createElement("img", { src: user.profile_photo_url, alt: user.name, className: "rounded-full h-20 w-20 object-cover" }))),
            react_1.default.createElement(SecondaryButton_1.default, { className: "mt-2 mr-2", type: "button", onClick: selectNewPhoto }, "Select A New Photo"),
            user.profile_photo_path ? (react_1.default.createElement(SecondaryButton_1.default, { type: "button", className: "mt-2", onClick: deletePhoto }, "Remove Photo")) : null,
            react_1.default.createElement(InputError_1.default, { message: form.errors.photo, className: "mt-2" }))) : null,
        react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
            react_1.default.createElement(Label_1.default, { htmlFor: "name", value: "Name" }),
            react_1.default.createElement(Input_1.default, { id: "name", type: "text", className: "mt-1 block w-full", value: form.data.name, onChange: function (e) { return form.setData('name', e.currentTarget.value); }, autoComplete: "name" }),
            react_1.default.createElement(InputError_1.default, { message: form.errors.name, className: "mt-2" })),
        react_1.default.createElement("div", { className: "col-span-6 sm:col-span-4" },
            react_1.default.createElement(Label_1.default, { htmlFor: "email", value: "Email" }),
            react_1.default.createElement(Input_1.default, { id: "email", type: "email", className: "mt-1 block w-full", value: form.data.email, onChange: function (e) { return form.setData('email', e.currentTarget.value); } }),
            react_1.default.createElement(InputError_1.default, { message: form.errors.email, className: "mt-2" }))));
}
exports.default = UpdateProfileInformationForm;
